import { render, staticRenderFns } from "./ai_answer.vue?vue&type=template&id=46f2ef2f&scoped=true"
import script from "./ai_answer.vue?vue&type=script&lang=js"
export * from "./ai_answer.vue?vue&type=script&lang=js"
import style0 from "./ai_answer.vue?vue&type=style&index=0&id=46f2ef2f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f2ef2f",
  null
  
)

export default component.exports